module.exports = __webpack_public_path__ + "media/audio6.5c7d5831.mp3";